import React from "react";
import { Box, Typography } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import styles from "./infoCard.module.scss";

interface InfoCardProps {
  type: "region" | "new_suppliers" | "custom";
  title: string;
  value: string | number;
  subtitle: string;
  backgroundColor?: string;
  icon?: React.ReactNode;
}

const InfoCard: React.FC<InfoCardProps> = ({
  type,
  title,
  value,
  subtitle,
  backgroundColor,
  icon,
}) => {
  const getCardConfig = () => {
    switch (type) {
      case "region":
        return {
          background: backgroundColor || "linear-gradient(180deg, #00D2AA 0%, #00B290 100%",
          icon: icon || <LocationOnIcon className={styles.icon} />,
        };
      case "new_suppliers":
        return {
          background: backgroundColor || "linear-gradient(180deg, #455391 0%, #6B7FD7 100%",
          icon: icon || <CalendarTodayIcon className={styles.icon} />,
        };
      case "custom":
        return {
          background: backgroundColor || "#5b6b9e",
          icon: icon || null,
        };
      default:
        return {
          background: "#5b6b9e",
          icon: null,
        };
    }
  };

  const cardConfig = getCardConfig();

  return (
    <Box className={styles.container} style={{ background: cardConfig.background }}>
      <Box className={styles.content}>
        <Box className={styles.contentGrid}>
        {cardConfig.icon && (
          <Box className={styles.iconWrapper}>{cardConfig.icon}</Box>
        )}
          <Typography className={styles.title}>{title}</Typography>
        </Box>
        <Box className={styles.textContent}>
          <Typography className={styles.value}>{value}</Typography>
          <Typography className={styles.subtitle}>{subtitle}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default InfoCard;
